/* eslint-disable react/no-unescaped-entities */
import { Tooltip } from "primereact/tooltip";

const PFTooltip = ({ type }: { type: string }) => {
  const year = [6.5, 6.25, 5.85, 6.0, 6.0, 6.0, 6.0, 6.0, 6.0, 6.0, 6.0];

  const showContentByType = () => {
    if (type === "blendedRate" || type === "year1Rate") {
      return (
        <div style={{ textAlign: "left", lineHeight: "1.5", fontSize: "13px" }} className="p-2">
          <p>
            The blended rate in a premium finance strategy refers to the average interest rate
            applied to the loan over the course of the borrowing period. It is calculated by
            averaging the interest rates applied each year of the loan.
          </p>
          <table style={{ width: "200px", borderCollapse: "collapse" }} className="mt-2">
            <tbody>
              {year.map((rate, i) => (
                <tr key={i}>
                  <td className="px-2 border-1 border-gray-300 font-bold">Year {i + 1}</td>
                  <td className="px-2 border-1 border-gray-300 font-bold">{rate.toFixed(2)}%</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="mt-[8px]">
            <strong>Loan Terms:</strong>
            <ul className="pl-[16px] mt-[4px]">
              <li>First Year rate: 6.5%</li>
              <li>2nd Year rate onwards: Prime + 0.50%</li>
              <li>Floating/Fixed for 5 Years</li>
              <li>Lender: WinTrust Bank</li>
            </ul>
          </div>

          <div className="mt-2">
            <strong>Disclaimer:</strong>
            <p>
              The terms and conditions outlined in this premium finance proposal are based on
              current market conditions and are subject to change prior to loan closing. The final
              loan terms, including interest rates, collateral requirements, and other associated
              conditions, may vary based on factors such as underwriting results, changes in market
              conditions, the insured&apos;s rating class, and additional financial or legal
              considerations. Any adjustments will be communicated promptly and will be contingent
              upon final approval from the lending institution. The proposal does not constitute a
              binding offer and should not be relied upon as a guarantee of the terms outlined
              herein.
            </p>
          </div>
        </div>
      );
    }
    if (type === "financialImpact") {
      return (
        <div style={{ lineHeight: "1.5", fontSize: "13px" }} className="p-2">
          <p>
            This represents the total financial impact of the strategy, combining all income
            received over the years with the final death benefit payout at the insured&apos;s age
            95. It illustrates the long-term value and wealth amplification achieved through premium
            financing.
          </p>

          <div className="mt-2">
            <strong>Disclaimer:</strong>
            <p>
              The terms and conditions outlined in this premium finance proposal are based on
              current market conditions and are subject to change prior to loan closing. The final
              loan terms, including interest rates, collateral requirements, and other associated
              conditions, may vary based on factors such as underwriting results, changes in market
              conditions, the insured&apos;s rating class, and additional financial or legal
              considerations. Any adjustments will be communicated promptly and will be contingent
              upon final approval from the lending institution. The proposal does not constitute a
              binding offer and should not be relied upon as a guarantee of the terms outlined
              herein.
            </p>
          </div>
        </div>
      );
    }
    if (type === "leverage") {
      return (
        <div style={{ lineHeight: "1.5", fontSize: "13px" }} className="p-2">
          <p className="mb-3">
            For every dollar of out-of-pocket expense—including any direct premium payments,
            interest, and financing or administrative fees—the policyholder is able to control a
            larger amount of life insurance premiums. For example, if the Effective Leverage Ratio
            is 4.50:1, it means that for every dollar the policyholder pays from their own pocket,
            they are leveraging it to control $4.50 of insurance premium.
          </p>

          <p className="mb-3">
            This ratio reflects the true economic leverage of the strategy because it accounts for
            all the actual cash costs borne by the policyholder, not just their initial
            contribution. While a higher ratio can amplify the potential advantages of premium
            financing—such as enhanced estate liquidity, wealth transfer, and tax efficiency—it also
            magnifies the risks tied to policy performance, loan management, and collateral
            requirements.
          </p>

          <p className="mb-3">
            There is no universally "too high" effective leverage ratio. The appropriate level
            depends on the policyholder’s financial situation, objectives, and risk tolerance. A
            higher ratio means greater magnification of both the potential benefits and the
            potential downsides, making it critical to evaluate the structure carefully and consult
            with qualified professionals before implementation.
          </p>

          <div>
            <strong>Disclaimer:</strong>
            <p>
              The terms and conditions outlined in this premium finance proposal are based on
              current market conditions and are subject to change prior to loan closing. The final
              loan terms, including interest rates, collateral requirements, and other associated
              conditions, may vary based on factors such as underwriting results, changes in market
              conditions, the insured's rating class, and additional financial or legal
              considerations. Any adjustments will be communicated promptly and will be contingent
              upon final approval from the lending institution. The proposal does not constitute a
              binding offer and should not be relied upon as a guarantee of the terms outlined
              herein.
            </p>
          </div>
        </div>
      );
    }
    return null; // Return null if the type doesn't match, so nothing is rendered in the tooltip
  };
  return (
    <>
      <i
        className="pi pi-info-circle cursor-help text-lg text-[#2A7FFF]"
        id={`summary-pf-tooltip-${type}`}
      />
      <Tooltip
        target={`#summary-pf-tooltip-${type}`}
        className={type === "financialImpact" ? "max-w-[500px]" : "max-w-[700px]"}
      >
        {showContentByType()}
      </Tooltip>
    </>
  );
};

export default PFTooltip;
